import { render, staticRenderFns } from "./statistical-analysis-sidebar.vue?vue&type=template&id=1c5430e0&"
import script from "./statistical-analysis-sidebar.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-sidebar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports